import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { replaceCitations } from '@Utils/String';
import capitalize from 'lodash/capitalize';

import './AlertContextTitle.scss';

export default function AlertContextTitle({ context, className }) {
  const displayContext = capitalize(replaceCitations(context));

  return (
    <h3 className={classnames('alert-context-title', 'u-els-font-size-h4', className)}>
      <span className="alert-context-title--text">{displayContext}</span>
    </h3>
  );
}

AlertContextTitle.propTypes = {
  context: PropTypes.string.isRequired,
  className: PropTypes.string,
};
